export interface ProviderMenuItem {
  title: string;
  href: string;
}

export const PROVIDER_MENU: ProviderMenuItem[] = [
  { title: "프로그램 등록안내", href: "/provider/guide" },
  { title: "프로그램 등록", href: "/provider/program/new" },
  { title: "프로그램 운영 내역", href: "/provider/programs" },
  { title: "회원정보 수정", href: "/provider/profile" },
];

export const PROVIDER_AUTH_MENU: ProviderMenuItem[] = [
  { title: "로그인", href: "/provider/login" },
  { title: "아이디 찾기", href: "/provider/find-id" },
  { title: "비밀번호 재설정", href: "/provider/find-password" },
  { title: "회원가입", href: "/provider/register" },
];
